<template>
  <div class="banner">
    <div id="particles-js"></div>
    <div class="container">
      <img class="img-welcome" src="../assets/welcome.png" alt="" />
      <div class="search-input-wrapper">
        <div class="select-box">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              {{ curMenu ? curMenu.label : "请选择"
              }}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in menuList"
                :key="item.id"
                :command="index"
                >{{ item.label }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="input-wrapper">
          <input
            type="text"
            placeholder="请输入账户地址 / 交易哈希 / 商品ID / XID数字身份"
            v-model="key"
            @keyup.enter="getReuslt()"
          />
        </div>
      </div>
      <div class="btn-search" @click.stop="getReuslt()"></div>
      <img class="img-earth" src="../assets/earth.png" alt="" />
    </div>
  </div>
</template>
<script>
export default {
  name: "search",
  props: {
    curType: {
      type: String,
      default: "",
    },
    curKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      screenWidth: 0,
      menuList: [
        {
          id: "goods_id",
          label: "商品ID",
        },
        {
          id: "trade_hash",
          label: "交易哈希",
        },
        {
          id: "addr",
          label: "账户地址",
        },
        {
          id: "xid",
          label: "XID数字身份",
        },
      ],
      curMenu: null,
      key: "",
    };
  },
  watch: {
    curType: {
      handler(val) {
        if (val) {
          this.curMenu = this.menuList.filter((item) => {
            return item.id === val;
          })[0];
        } else {
          this.curMenu = null;
        }
      },
      immediate: true,
    },
    curKey: {
      handler(val) {
        this.key = val;
      },
      immediate: true,
    },
  },
  mounted() {
    // 获取屏幕尺寸
    this.screenWidth = document.body.clientWidth;
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth;
      })();
    };
  },
  methods: {
    handleCommand(command) {
      this.curMenu = this.menuList[command];
    },
    getReuslt() {
      let { type, key } = this.$route.query;
      let routeName = this.$route.name;

      if (!this.curMenu) {
        this.$message.error("请选择查询类型");
        return;
      }
      if (!this.key) {
        this.$message.error("请输入查询内容");
        return;
      }
      if (this.curMenu.id === "goods_id" && !(this.key > 0)) {
        this.$message.error("查询内容不正确");
        return;
      }
      if (this.curMenu.id !== "goods_id" && this.key > 0) {
        this.$message.error("查询内容不正确,是否要查询商品ID?");
        return;
      }
      if (routeName === "search" && type === this.curMenu.id && key === this.key) {
        this.$emit("searchKey", {
          type: this.curMenu.id,
          key: this.key,
        });
        return;
      }
      this.$router.push(`search?type=${this.curMenu.id}&key=${this.key}`);
    },
  },
};
</script>
<style scoped>
.select-box .el-dropdown {
  height: 52px;
  line-height: 52px;
  color: #fff;
  font-size: 18px;
}
.banner {
  position: relative;
}

.banner:after {
  content: "";
  width: 1380px;
  height: 1160px;
  background-image: url("../assets/decoration.png");
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: -200px;
  z-index: -1;
}

#particles-js {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.banner .container {
  max-width: 1200px;
  position: relative;
  z-index: 1;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 80px 20px;
}

.banner .img-welcome {
  width: 645px;
  height: 168px;
}

.banner .search-input-wrapper {
  max-width: 694px;
  padding: 0 1px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-top: 20px;
  position: relative;
}

.banner .search-input-wrapper .select-box {
  height: 60px;
  box-sizing: border-box;
  position: relative;
  flex-shrink: 0;
  padding: 0 24px;
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: linear-gradient(
    69deg,
    rgba(69, 42, 124, 0.8) 10.42%,
    rgba(69, 42, 124, 0.1) 77.11%
  );
  box-shadow: 0px 1.197px 29.915px 0px #452a7c;
  backdrop-filter: blur(100px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-input-wrapper .select-box .el-dropdown {
  cursor: pointer;
}

.banner .search-input-wrapper .input-wrapper {
  width: 500px;
  border-radius: 32px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  background: linear-gradient(
    69deg,
    rgba(69, 42, 124, 0.8) 10.42%,
    rgba(69, 42, 124, 0.1) 77.11%
  );
  box-shadow: 0px 1.197px 29.915px 0px #452a7c;
  backdrop-filter: blur(100px);
  margin-left: 5px;
}

.banner .search-input-wrapper input {
  height: 60px;
  flex: 1;
  background: none;
  font-size: 18px;
  color: #fff;
  border: none;
  padding: 0 15px;
  width: 100%;
  box-sizing: border-box;
}

.banner .search-input-wrapper input:focus {
  outline: none;
}

.banner .search-input-wrapper ::-webkit-input-placeholder {
  color: #a5a5a5;
}

.banner .search-input-wrapper ::-moz-placeholder {
  color: #a5a5a5;
}

.banner .search-input-wrapper ::-ms-input-placeholder {
  color: #a5a5a5;
}

.banner .btn-search {
  width: 180px;
  height: 46px;
  cursor: pointer;
  background: #000 url("../assets/btn-search.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 30px;
  margin-top: 20px;
}

.banner .img-earth {
  width: 500px;
  position: absolute;
  top: 0;
  right: 0;
}

@media (max-width: 1199px) {
  .select-box .el-dropdown {
    height: 30px;
    line-height: 30px;
    font-size: 11px;
  }
  .banner:after {
    width: 100%;
    height: 300px;
    background-image: url("../assets/decoration.png");
    left: 0;
    top: 50px;
  }
  .banner .container {
    padding: 50px 10px;
  }
  .banner .img-welcome {
    width: 322.5px;
    height: 84px;
  }
  .banner .search-input-wrapper {
    margin-top: 20px;
  }
  .banner .search-input-wrapper .select-box {
    height: 30px;
    padding: 0 12px;
    border-radius: 16px;
  }
  .banner .search-input-wrapper .input-wrapper {
    width: 500px;
    border-radius: 32px;
    margin-left: 5px;
  }
  .banner .search-input-wrapper input {
    height: 30px;
    font-size: 11px;
    padding: 0 8px;
  }
  .banner .btn-search {
    width: 118px;
    height: 30px;
    border-radius: 15px;
    margin-top: 10px;
  }
  .banner .img-earth {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue